export const amountDiscountType = [
  { value: 1, name: "Percentage" },
  { value: 2, name: "Fixed" },
];

export const statusOptions = [
  {
    name: "Pending",
    value: 0,
  },
  {
    name: "Delivered",
    value: 1,
  },
  {
    name: "Cancel",
    value: 2,
  },
];

export const orderStatus = { pending: 0, delivered: 1, cancelled: 2 };
export const paymentStatus = { pending: 1, complete: 2 };
export const orderPaymentType = { banktransfer: 1, bitcoin: 2 };
export const systemDiscount = { coupon: 1, itemdiscount: 2 };

export const pageTitles = {
  coupons: "Coupons",
  editCoupon: "Edit Coupon",
  addCoupon: "Add Coupon",
  itemDiscounts: "Item Discounts",
  editItemDiscount: "Edit Item Discount",
  addItemDiscount: "Add Item Discount",
  orders: "Orders",
  category: "Category",
  addProduct: "Add Product",
  products: "Products",
  editProducts: "Edit Product",
  setting: "Setting",
  userDetails: "User Details",
  users: "Users",
}

export const sortTypes = {
  priceLowest: "price-lowest",
  priceHighest: "price-highest",
  sortAscending: "name-a",
  sortDecending: "name-z",
  incriment: "inc",
  decriment: "dec",
};

export const validationTypes = {
  minLength: "minLength",
  maxLength: "maxLength",
  required: "required",
  pattern: "pattern",
  manual: "manual",
};

export const allProducts = {
  allProducts: "all",
};

export const eyeName = {
  eye: "eye",
};

export const userType = {
  admin: 1,
};
